// extracted by mini-css-extract-plugin
module.exports = {"Screen":"SplashScreenRed_Screen__11Vin","ScreenLogo":"SplashScreenRed_ScreenLogo__Y43p5"};